import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../../app/api/routes';
import { createErrorMessage } from '../../../app/helpers/createErrorMessage';
import {
  ONBOARDING_TEMPLATES_RESOURCE,
  UPDATE_ONBOARDING_TEMPLATE_RESOURCE,
} from '../../constants';

const UpdateOnboardingTemplateService = ComposedComponent =>
  reduxFetch([
    {
      resource: UPDATE_ONBOARDING_TEMPLATE_RESOURCE,
      method: 'put',
      request: (id, body, callback, rejectCallback, t) => ({
        url: apiRoutes.onboardingTemplates(id),
        body,
        meta: {
          callback,
          rejectCallback,
          updateOtherList: {
            id,
            idProp: 'id',
            resource: ONBOARDING_TEMPLATES_RESOURCE,
          },
          toaster: {
            onErrorMessage: createErrorMessage(t, 'updateOnboardingTemplateFailed'),
            onSuccessMessage: t('updateOnboardingTemplateSuccess'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default UpdateOnboardingTemplateService;
